<template>
  <div class="heatmap-report">
    <OLoadingDialog :value="isLoading" />

    <v-card>
      <v-toolbar class="card-bar">
        <v-toolbar-title>Heatmap</v-toolbar-title>

        <v-btn icon class="mx-2" @click="reload()">
          <v-icon>refresh</v-icon>
        </v-btn>

        <HeatmapColorsMenu @input="setGradient" />

        <HeatmapOptsMenu :opts="opts" />

        <v-spacer />

        <HeatmapDatePicker :stats="stats" v-model="dateRange" />

        <v-spacer />

        <div
          style="width: 300px; text-align: right; color: #999"
          class="caption"
        >
          {{ positions.length }} pontos, maxW {{ maxWeight }}, totalW
          {{ totalWeight }}
        </div>
      </v-toolbar>

      <OLoadingLine absolute :value="isLoading" />

      <div class="heatmap-wrapper">
        <OMap ref="theMap" />
      </div>
    </v-card>
  </div>
</template>

<script>
import utils from 'oderon-commons/src/utils'
import OMap from 'oderon-vue/maps/OMap.vue'
import HeatmapDatePicker from './HeatmapDatePicker.vue'
import HeatmapOptsMenu from './HeatmapOptsMenu.vue'
import HeatmapColorsMenu from './HeatmapColorsMenu.vue'

export default {
  components: {
    OMap,
    HeatmapDatePicker,
    HeatmapOptsMenu,
    HeatmapColorsMenu
  },
  props: {
    fetcher: { required: true }
  },
  data() {
    return {
      isLoading: false,

      opts: {
        radius: null,
        maxIntensity: null,
        dissipating: true
      },

      positions: [],
      maxWeight: null,
      totalWeight: null,
      heatmap: null,
      stats: null,
      didFit: false,

      dateRange: []
    }
  },
  mounted() {
    this.reload()
  },
  computed: {
    apiParams() {
      return {
        fromDate: this.dateRange[0],
        untilDate: this.dateRange[1]
      }
    }
  },
  watch: {
    apiParams() {
      this.$loading(() => this.fetchData())
    },
    opts: {
      handler() {
        this.applyOpts()
      },
      deep: true
    }
  },
  methods: {
    reload() {
      this.$loading(() => this.fetchData())
    },

    async fetchData() {
      this.stats = await this.fetcher.fetchStats()
      if (this.stats.max != null && this.dateRange.length < 1) {
        this.dateRange = [
          utils.sod(this.stats.max.timestamp),
          utils.sod(this.stats.max.timestamp, 1)
        ]
      }

      this.positions = await this.fetcher.fetchPositions(this.apiParams)
      this.maxWeight = utils.maxBy(this.positions, 'w')
      this.totalWeight = utils.sumBy(this.positions, 'w')

      this.makeHeatmap()
    },

    makeHeatmap() {
      let data = this.positions.map((x) => {
        return {
          // eslint-disable-next-line no-undef
          location: new google.maps.LatLng(x.lat, x.lng),
          weight: x.w
        }
      })

      if (this.heatmap == null) {
        // eslint-disable-next-line no-undef
        this.heatmap = new google.maps.visualization.HeatmapLayer({ data })
        this.$refs.theMap.addObject(this.heatmap)
      } else {
        this.heatmap.setData(data)
      }

      if (!this.didFit) {
        this.didFit = true
        // eslint-disable-next-line no-undef
        let bounds = new google.maps.LatLngBounds()
        data.forEach((x) => bounds.extend(x.location))
        this.$refs.theMap.fitBounds(bounds)
      }
    },

    setGradient(g) {
      this.heatmap.set('gradient', g)
    },

    applyOpts() {
      let radius = parseFloat(this.opts.radius)
      this.heatmap.set('radius', Number.isNaN(radius) ? null : radius)

      let maxIntensity = parseFloat(this.opts.maxIntensity)
      this.heatmap.set(
        'maxIntensity',
        Number.isNaN(maxIntensity) ? null : maxIntensity
      )

      this.heatmap.set('dissipating', this.opts.dissipating)
    }
  }
}
</script>

<style lang="sass">
.heatmap-report
  > .v-card
    display: flex
    flex-flow: column nowrap
    justify-content: stretch
    height: 100%

    header
      flex-grow: 0

    .heatmap-wrapper
      position: relative
      flex-grow: 1
</style>
